import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'
import { COLORS } from '../../data/enums'

export default function Iris({ rotation, maskPath, transformOrigin, gradientId }) {
  const [originX, originY] = transformOrigin?.split(' ') || [0, 0]
  const maskId = `_${useRandomId()}`
  return (
    <g>
      <mask id={maskId}>
        <path d={maskPath} fill={COLORS.WHITE} transform={`rotate(${-rotation})`} transform-origin={transformOrigin} />
      </mask>
      <circle
        transform={`rotate(${rotation})`}
        transform-origin={transformOrigin}
        style={{ mask: `url(#${maskId})` }}
        cx={originX}
        cy={originY}
        r="5"
        fill={`url(#${gradientId})`}
      />
    </g>
  )
}
